export default __webpack_public_path__ + "static/layout-do-dark-8d6e40db95b3a099a7729413b3f678c857ff6273430752f532f6e0018da3715e.png";